module.exports = __webpack_public_path__ + "static/media/step3.f5078c63.png";